import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: '',
        user: '',
        cookie_user: '',
    },
    mutations: {
        increment(state) {
            // 变更状态
            state.token = ''
            state.user = ''
            state.cookie_user = ''
        },
        upUserInfo(state,data){
            state.user = data
            state.cookie_user = data
        }
    },
    actions: {
        LogOut(context) {
            context.commit('increment')
        },
        upUserInfo(context,data) {
            context.commit('upUserInfo',data)
        },
    },
    modules: {
    }
})
